import { Link, useNavigate, useLocation } from "react-router-dom";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_virtual-stage-uk/artifacts/ajtw0a03_TSS%20logo%20update%20transparentlight.png";

function ScrollLink({ to, children, className }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = (e) => {
    e.preventDefault();
    const sectionId = to.replace("/#", "");
    if (location.pathname === "/") {
      const el = document.getElementById(sectionId);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/");
      setTimeout(() => {
        const el = document.getElementById(sectionId);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 300);
    }
  };

  return (
    <a href={to} onClick={handleClick} className={className}>
      {children}
    </a>
  );
}

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-[#0D2D54] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src={LOGO_URL} alt="The Secret Seller" className="h-12 w-auto" />
              <h3 className="font-['Outfit'] text-xl font-semibold text-white">
                The Secret Seller
              </h3>
            </div>
            <p className="text-sm text-white/60 leading-relaxed">
              The UK's premier virtual staging service. Helping estate agents, developers and landlords sell property faster.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-['Outfit'] text-sm uppercase tracking-[0.2em] text-[#758C7B] mb-4">
              Services
            </h4>
            <ul className="space-y-3 text-sm text-white/60">
              <li>
                <Link to="/virtual-staging-uk" className="hover:text-white transition-colors">
                  Virtual Staging
                </Link>
              </li>
              <li>
                <Link to="/3d-property-rendering-uk" className="hover:text-white transition-colors">
                  3D Renders
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-['Outfit'] text-sm uppercase tracking-[0.2em] text-[#758C7B] mb-4">
              Quick Links
            </h4>
            <ul className="space-y-3 text-sm text-white/60">
              <li>
                <Link to="/order" className="hover:text-white transition-colors">
                  Order Now
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-white transition-colors">
                  All Services
                </Link>
              </li>
              <li>
                <ScrollLink to="/#pricing" className="hover:text-white transition-colors cursor-pointer">
                  Pricing
                </ScrollLink>
              </li>
              <li>
                <ScrollLink to="/#how-it-works" className="hover:text-white transition-colors cursor-pointer">
                  How It Works
                </ScrollLink>
              </li>
              <li>
                <ScrollLink to="/#faq" className="hover:text-white transition-colors cursor-pointer">
                  FAQ
                </ScrollLink>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-['Outfit'] text-sm uppercase tracking-[0.2em] text-[#758C7B] mb-4">
              Get In Touch
            </h4>
            <p className="text-sm text-white/60 mb-3">
              UK-based service with 48-hour delivery
            </p>
            <a
              href="mailto:rachel@thesecretseller.co.uk"
              className="text-sm text-[#758C7B] hover:text-white transition-colors block mb-4"
            >
              rachel@thesecretseller.co.uk
            </a>
            <Link
              to="/order"
              data-testid="footer-order-btn"
              className="inline-block bg-white text-[#0D2D54] px-6 py-2.5 text-sm font-semibold hover:bg-white/90 transition-all"
            >
              Start Your Order
            </Link>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-white/40">
            &copy; {new Date().getFullYear()} The Secret Seller. All rights reserved.
          </p>
          <p className="text-xs text-white/40">
            Virtual staging and 3D renders delivered in 48 hours
          </p>
        </div>
      </div>
    </footer>
  );
}
